export const HTML_CHAR = {
  BULLET: <>&#x2022;</>,
};

export const EMPTY_FIELD_PLACEHOLDER = 'N/A';

export const CANCELLED_STATUSES = ['cancelled', 'cancel', 'rejected'];
